const STORAGE_KEY = "stayeasy.bookingDraft";

export const saveBookingDraft = (draft) => {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
};

export const getBookingDraft = () => {
  if (typeof window === "undefined") return null;

  try {
    const value = window.sessionStorage.getItem(STORAGE_KEY);
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

export const clearBookingDraft = () => {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(STORAGE_KEY);
};

export const bookingDraftKey = STORAGE_KEY;
